import { Flex } from "@chakra-ui/react";
import Stay22HotelBooking from "@components/Stay22/Stay22HotelBooking";
import {
  CalendarCard,
  ContactUsCard,
  CreateEventCard,
  ShareEventCard,
} from "../CheckoutSuccessCTA/CheckoutSuccessCTACards";
import CheckoutSuccessContainer from "../CheckoutSuccessContainer/CheckoutSuccessContainer";
import CheckoutSuccessHeadings from "../CheckoutSuccessHeadings/CheckoutSuccessHeadings";
import { CheckoutSuccessContentProps } from "../types";

const HOST = process.env.NEXT_PUBLIC_HOST || "https://app.moongate.id";

const CheckoutSuccessTicket = ({
  event,
  tier,
  info,
  itemsCount,
  language,
}: CheckoutSuccessContentProps) => {
  return (
    <>
      <CheckoutSuccessContainer>
        <CheckoutSuccessHeadings heading="Purchase Confirmed!" />
        <Flex
          width="full"
          direction={{ base: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems="center"
          gap={4}
        >
          <CalendarCard
            info={info}
            language={language}
            start={event?.start}
            end={event?.end}
            timezone={event?.timezone}
          />
          <ShareEventCard
            eventType={event.type}
            language={language}
            url={event.toURL(HOST)}
          />
          <CreateEventCard language={language} type={event.type} />
          <ContactUsCard language={language} />
        </Flex>
        <Stay22HotelBooking info={info} event={event} />
      </CheckoutSuccessContainer>
    </>
  );
};

export default CheckoutSuccessTicket;
